/**
 * HailProtector Vehicle Data - v2.3.0
 * FALLBACK ONLY — DB (Supabase edge function) is source of truth.
 * This file is used only when the API is unreachable.
 *
 * Size Codes (per official sizing chart, corrected 2026-03-05):
 * - CAR1: Sentinel Compact (up to 175" long)
 * - CAR2: Sentinel Mid-Size (176" – 195" long)
 * - CAR3: Sentinel Full-Size (196" – 211" long)
 * - SUV1: Guardian Compact (up to 197" long)
 * - SUV2: Guardian Mid-Size (198" – 233" long)
 * - SUV3: Guardian Full-Size (234" – 270" long)
 *
 * v2.3.0: Demoted to fallback-only; DB is now primary source of truth
 * v2.2.0: Dimension-verified codes via autoevolution CSV + meta backfill
 * v2.1.0: Corrected all size boundaries to match official sizing chart
 * v2.0.0: Initial vehicle database aligned to fitment V2 migration
 */

window.HailProtector = window.HailProtector || {};

window.HailProtector.vehicleData = {
  'Acura': {
    'ILX': 'CAR2',
    'Integra': 'CAR2',
    'TLX': 'CAR2',
    'RLX': 'CAR3',
    'RDX': 'SUV1',
    'MDX': 'SUV2'
  },
  'Audi': {
    'A3': 'CAR1',
    'A4': 'CAR2',
    'A5': 'CAR2',
    'A6': 'CAR2',
    'A7': 'CAR3',
    'A8': 'CAR3',
    'Q3': 'SUV1',
    'Q5': 'SUV1',
    'Q7': 'SUV2',
    'Q8': 'SUV1',
    'e-tron': 'SUV1',
    'e-tron GT': 'CAR3'
  },
  'BMW': {
    '2 Series': 'CAR2',
    '3 Series': 'CAR2',
    '4 Series': 'CAR2',
    '5 Series': 'CAR3',
    '7 Series': 'CAR3',
    '8 Series': 'CAR2',
    'i4': 'CAR2',
    'i7': 'CAR3',
    'iX': 'SUV1',
    'X1': 'SUV1',
    'X3': 'SUV1',
    'X5': 'SUV1',
    'X7': 'SUV2'
  },
  'Buick': {
    'Enclave': 'SUV2',
    'Encore': 'SUV1',
    'Encore GX': 'SUV1',
    'Envision': 'SUV1'
  },
  'Cadillac': {
    'CT4': 'CAR2',
    'CT5': 'CAR2',
    'Escalade': 'SUV2',
    'Escalade ESV': 'SUV3',
    'Lyriq': 'SUV1',
    'XT4': 'SUV1',
    'XT5': 'SUV1',
    'XT6': 'SUV2'
  },
  'Chevrolet': {
    'Blazer': 'SUV1',
    'Bolt EV': 'CAR1',
    'Bolt EUV': 'SUV1',
    'Camaro': 'CAR2',
    'Colorado': 'SUV2',
    'Corvette': 'CAR2',
    'Equinox': 'SUV1',
    'Malibu': 'CAR2',
    'Silverado 1500': 'SUV2',
    'Silverado 2500HD': 'SUV3',
    'Silverado 3500HD': 'SUV3',
    'Spark': 'CAR1',
    'Suburban': 'SUV2',
    'Tahoe': 'SUV2',
    'Trailblazer': 'SUV1',
    'Traverse': 'SUV2',
    'Trax': 'SUV1'
  },
  'Chrysler': {
    '300': 'CAR3',
    'Pacifica': 'SUV2',
    'Voyager': 'SUV2'
  },
  'Dodge': {
    'Challenger': 'CAR3',
    'Charger': 'CAR3',
    'Durango': 'SUV2',
    'Hornet': 'SUV1'
  },
  'Ford': {
    'Bronco': 'SUV1',
    'Bronco Sport': 'SUV1',
    'Edge': 'SUV1',
    'Escape': 'SUV1',
    'Expedition': 'SUV2',
    'Expedition Max': 'SUV2',
    'Explorer': 'SUV2',
    'F-150': 'SUV2',
    'F-150 Lightning': 'SUV2',
    'F-250': 'SUV3',
    'F-350': 'SUV3',
    'Maverick': 'SUV2',
    'Mustang': 'CAR2',
    'Mustang Mach-E': 'SUV1',
    'Ranger': 'SUV2'
  },
  'Genesis': {
    'G70': 'CAR2',
    'G80': 'CAR3',
    'G90': 'CAR3',
    'GV60': 'SUV1',
    'GV70': 'SUV1',
    'GV80': 'SUV1'
  },
  'GMC': {
    'Acadia': 'SUV1',
    'Canyon': 'SUV2',
    'Hummer EV': 'SUV2',
    'Sierra 1500': 'SUV2',
    'Sierra 2500HD': 'SUV3',
    'Sierra 3500HD': 'SUV3',
    'Terrain': 'SUV1',
    'Yukon': 'SUV2',
    'Yukon XL': 'SUV2'
  },
  'Honda': {
    'Accord': 'CAR2',
    'Civic': 'CAR2',
    'CR-V': 'SUV1',
    'CR-V Hybrid': 'SUV1',
    'HR-V': 'SUV1',
    'Odyssey': 'SUV2',
    'Passport': 'SUV1',
    'Pilot': 'SUV1',
    'Ridgeline': 'SUV2'
  },
  'Hyundai': {
    'Elantra': 'CAR2',
    'Ioniq 5': 'SUV1',
    'Ioniq 6': 'CAR2',
    'Kona': 'SUV1',
    'Palisade': 'SUV1',
    'Santa Cruz': 'SUV1',
    'Santa Fe': 'SUV1',
    'Sonata': 'CAR2',
    'Tucson': 'SUV1',
    'Venue': 'SUV1'
  },
  'Infiniti': {
    'Q50': 'CAR2',
    'Q60': 'CAR2',
    'QX50': 'SUV1',
    'QX55': 'SUV1',
    'QX60': 'SUV2',
    'QX80': 'SUV2'
  },
  'Jaguar': {
    'E-Pace': 'SUV1',
    'F-Pace': 'SUV1',
    'F-Type': 'CAR2',
    'I-Pace': 'SUV1',
    'XF': 'CAR3'
  },
  'Jeep': {
    'Cherokee': 'SUV1',
    'Compass': 'SUV1',
    'Gladiator': 'SUV2',
    'Grand Cherokee': 'SUV1',
    'Grand Cherokee L': 'SUV2',
    'Grand Wagoneer': 'SUV2',
    'Renegade': 'SUV1',
    'Wagoneer': 'SUV2',
    'Wrangler': 'SUV1',
    'Wrangler Unlimited': 'SUV1'
  },
  'Kia': {
    'Carnival': 'SUV2',
    'EV6': 'SUV1',
    'Forte': 'CAR2',
    'K5': 'CAR2',
    'Niro': 'SUV1',
    'Seltos': 'SUV1',
    'Sorento': 'SUV1',
    'Soul': 'SUV1',
    'Sportage': 'SUV1',
    'Telluride': 'SUV1'
  },
  'Land Rover': {
    'Defender': 'SUV1',
    'Defender 130': 'SUV2',
    'Discovery': 'SUV1',
    'Discovery Sport': 'SUV1',
    'Range Rover': 'SUV2',
    'Range Rover Evoque': 'SUV1',
    'Range Rover Sport': 'SUV1',
    'Range Rover Velar': 'SUV1'
  },
  'Lexus': {
    'ES': 'CAR2',
    'GX': 'SUV1',
    'IS': 'CAR2',
    'LC': 'CAR2',
    'LS': 'CAR3',
    'LX': 'SUV2',
    'NX': 'SUV1',
    'RC': 'CAR2',
    'RX': 'SUV1',
    'RZ': 'SUV1',
    'TX': 'SUV2',
    'UX': 'SUV1'
  },
  'Lincoln': {
    'Aviator': 'SUV2',
    'Corsair': 'SUV1',
    'Nautilus': 'SUV1',
    'Navigator': 'SUV2',
    'Navigator L': 'SUV2'
  },
  'Mazda': {
    'CX-30': 'SUV1',
    'CX-5': 'SUV1',
    'CX-50': 'SUV1',
    'CX-9': 'SUV2',
    'CX-90': 'SUV2',
    'Mazda3': 'CAR2',
    'Mazda6': 'CAR2',
    'MX-5 Miata': 'CAR1'
  },
  'Mercedes-Benz': {
    'A-Class': 'CAR2',
    'C-Class': 'CAR2',
    'CLA': 'CAR2',
    'CLS': 'CAR3',
    'E-Class': 'CAR2',
    'EQB': 'SUV1',
    'EQE': 'CAR2',
    'EQE SUV': 'SUV1',
    'EQS': 'CAR3',
    'EQS SUV': 'SUV2',
    'G-Class': 'SUV1',
    'GLA': 'SUV1',
    'GLB': 'SUV1',
    'GLC': 'SUV1',
    'GLE': 'SUV1',
    'GLS': 'SUV2',
    'S-Class': 'CAR3'
  },
  'Mini': {
    'Clubman': 'CAR1',
    'Convertible': 'CAR1',
    'Countryman': 'SUV1',
    'Hardtop 2 Door': 'CAR1',
    'Hardtop 4 Door': 'CAR1'
  },
  'Mitsubishi': {
    'Eclipse Cross': 'SUV1',
    'Mirage': 'CAR1',
    'Outlander': 'SUV1',
    'Outlander Sport': 'SUV1'
  },
  'Nissan': {
    'Altima': 'CAR2',
    'Armada': 'SUV2',
    'Frontier': 'SUV2',
    'Kicks': 'SUV1',
    'Leaf': 'CAR2',
    'Maxima': 'CAR2',
    'Murano': 'SUV1',
    'Pathfinder': 'SUV2',
    'Rogue': 'SUV1',
    'Sentra': 'CAR2',
    'Titan': 'SUV2',
    'Titan XD': 'SUV3',
    'Versa': 'CAR2',
    'Z': 'CAR1'
  },
  'Porsche': {
    '718 Boxster': 'CAR1',
    '718 Cayman': 'CAR1',
    '911': 'CAR2',
    'Cayenne': 'SUV1',
    'Macan': 'SUV1',
    'Panamera': 'CAR3',
    'Taycan': 'CAR3'
  },
  'Ram': {
    '1500': 'SUV2',
    '2500': 'SUV3',
    '3500': 'SUV3',
    'ProMaster': 'SUV3'
  },
  'Rivian': {
    'R1S': 'SUV2',
    'R1T': 'SUV2'
  },
  'Subaru': {
    'Ascent': 'SUV1',
    'BRZ': 'CAR1',
    'Crosstrek': 'SUV1',
    'Forester': 'SUV1',
    'Impreza': 'CAR2',
    'Legacy': 'CAR2',
    'Outback': 'SUV1',
    'Solterra': 'SUV1',
    'WRX': 'CAR2'
  },
  'Tesla': {
    'Model 3': 'CAR2',
    'Model S': 'CAR3',
    'Model X': 'SUV2',
    'Model Y': 'SUV1',
    'Cybertruck': 'SUV2'
  },
  'Toyota': {
    '4Runner': 'SUV1',
    'bZ4X': 'SUV1',
    'Camry': 'CAR2',
    'Corolla': 'CAR2',
    'Corolla Cross': 'CAR2',
    'Crown': 'CAR3',
    'GR86': 'CAR1',
    'GR Corolla': 'CAR1',
    'GR Supra': 'CAR1',
    'Grand Highlander': 'SUV2',
    'Highlander': 'SUV1',
    'Land Cruiser': 'SUV1',
    'Prius': 'CAR2',
    'RAV4': 'SUV1',
    'Sequoia': 'SUV2',
    'Sienna': 'SUV2',
    'Tacoma': 'SUV2',
    'Tundra': 'SUV2',
    'Venza': 'SUV1'
  },
  'Volkswagen': {
    'Arteon': 'CAR2',
    'Atlas': 'SUV2',
    'Atlas Cross Sport': 'SUV1',
    'Golf GTI': 'CAR1',
    'Golf R': 'CAR1',
    'ID.4': 'SUV1',
    'Jetta': 'CAR2',
    'Passat': 'CAR2',
    'Taos': 'SUV1',
    'Tiguan': 'SUV1'
  },
  'Volvo': {
    'C40 Recharge': 'SUV1',
    'S60': 'CAR2',
    'S90': 'CAR3',
    'V60': 'CAR2',
    'V90': 'CAR3',
    'XC40': 'SUV1',
    'XC60': 'SUV1',
    'XC90': 'SUV1'
  }
};

// Helper functions exposed on namespace
window.HailProtector.sizeToSystem = function(code) {
  if (!code || typeof code !== 'string') return 'sentinel';
  return code.indexOf('CAR') === 0 ? 'sentinel' : 'guardian';
};

window.HailProtector.sizeNames = {
  'CAR1': 'Sentinel Compact',
  'CAR2': 'Sentinel Mid-Size',
  'CAR3': 'Sentinel Full-Size',
  'SUV1': 'Guardian Compact',
  'SUV2': 'Guardian Mid-Size',
  'SUV3': 'Guardian Full-Size'
};

// Lookup function
window.HailProtector.getVehicleSize = function(make, model) {
  const makeData = this.vehicleData[make];
  if (!makeData) return null;
  return makeData[model] || null;
};
